import { memo } from 'react'
import { ButtonBase } from '@mui/material'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import Button from '../../Button'
import { currencyAndLocationButtonStyles as styles } from './CurrencyAndLocationButton.style'
import { CurrencyAndLocationButtonProps } from './CurrencyAndLocationButton.types'

function CurrencyAndLocationButton({ data, onClick }: CurrencyAndLocationButtonProps) {
  if (!data) return null

  return (
    <>
      <Button
        startIcon={<Box component={data.flag} sx={styles.flagIcon} />}
        color="secondary"
        sx={styles.mobile}
        onClick={onClick}>
        {data.value}
      </Button>

      <ButtonBase sx={styles.desktop} onClick={onClick}>
        <Box component={data.flag} sx={styles.flagIcon} />
        <Text sx={styles.desktopText}>{data.value}</Text>
      </ButtonBase>
    </>
  )
}

export default memo(CurrencyAndLocationButton)
